import { mkdir, writeFile } from "fs/promises";
import { join } from "path";
import { existsSync } from "fs";
const LOG_DIR = join(process.cwd(), "logs");
const LOG_FILE = join(LOG_DIR, "browser-logs.jsonl");
const POST = async ({ request }) => {
  try {
    const { logs } = await request.json();
    if (!existsSync(LOG_DIR)) {
      await mkdir(LOG_DIR, { recursive: true });
    }
    const logLines = logs.map((log) => JSON.stringify({
      ...log,
      serverTimestamp: (/* @__PURE__ */ new Date()).toISOString()
    })).join("\n") + "\n";
    await writeFile(LOG_FILE, logLines, { flag: "a" });
    return new Response(JSON.stringify({ success: true }), {
      status: 200,
      headers: {
        "Content-Type": "application/json"
      }
    });
  } catch (error) {
    console.error("Failed to write browser logs:", error);
    return new Response(JSON.stringify({
      error: "Failed to write logs",
      message: error instanceof Error ? error.message : "Unknown error"
    }), {
      status: 500,
      headers: {
        "Content-Type": "application/json"
      }
    });
  }
};
export {
  POST
};
